<div class="welcome-container">
    <div class="card">
      <h1>👋 Welcome to eMOS Dev/Test Page!</h1>
      <p>This page is intended for testing purpose.</p>
      <button (click)="goHome()">Enter App</button>
      <div class="grid">
        <div class="col-6">
            <div class="text-yellow-400 text-left">{{systemCheck}}</div>
            <div class="text-yellow-400 text-left">{{patientCheck}}</div>
        </div>
        <div class="col-6">
            <div class="text-yellow-400 text-right">{{cateringCheck}}</div>
            <div class="text-yellow-400 text-right">{{inventoryCheck}}</div>
        </div>
      </div>
    </div>
  </div>
